/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit RelationshipType/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaSelect from 'DesignSystem/TysiaSelect/index'
import TysiaSelectContent from 'DesignSystem/TysiaSelect/TysiaSelectContent/index'
import TysiaSelectField from 'DesignSystem/TysiaSelect/TysiaSelectField/react'



/** @type {import('Simple/types.js').View} */
export default function RelationshipType({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Relations/AddRelation/Search/Content/Profiles/Content/Profile/AddPersonRelation/Content/CopyRelationships/Content/Relationships/Content/CopyRelationshipItem/RelationshipType",
  onChange,
  isInvalid
  
}) {
let optionsRelationshipsValueData = fromData.useDataValue({ viewPath,
context: 'options',
path: 'relationships',
})
let relationshipTypeValueData = fromData.useDataValue({ viewPath,
context: 'relationship',
path: 'type',
})
let relationshipTypeIsValidData = fromData.useDataIsValid({ viewPath,
context: 'relationship',
path: 'type',
validate: fromValidate.text,
required: true,
})
let relationshipTypeChangeData = fromData.useDataChange({ viewPath,
context: 'relationship',
path: 'type',
})
  return (<React.Fragment
>
<TysiaSelect
  viewPath={`${viewPath}/TysiaSelect`}
 marginTop={0}
 data="options.relationships"
 from={optionsRelationshipsValueData}
 data="relationship.type"
 value={relationshipTypeValueData}
 onChange={relationshipTypeChangeData}
 validate="/Data/validate.js text"
 invalid={!relationshipTypeIsValidData}
 required={true}
>
{childProps => (
<TysiaSelectContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectContent`}
>
{childProps => (
<TysiaSelectField
{...childProps}
  viewPath={`${viewPath}/TysiaSelectField`}
/>
)}
</TysiaSelectContent>
)}
</TysiaSelect>
{children}
</React.Fragment>)
}